module.exports = __webpack_public_path__ + "img/Target_case_study_2.531894ef.jpg";